import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { messagesSelectors } from 'store/messages'
import { Marker, MarkerContent, MarkerIcon } from '@/components/ui/marker'

// The wait is mostly the model reasoning and calling tools, not writing: say so, and rotate
// through a few phrasings so a long wait does not look like a frozen label.
const ROTATE_MS = 3000

// Where the next wait starts. It keeps advancing across waits, otherwise every answer would open
// on the same first line and only a long wait would ever show the rest.
let nextStart = 0

export const BotTyping = () => {
  const { t } = useTranslation()
  const botTyping = useSelector(messagesSelectors.botTyping)
  const messages = t('botThinking', { returnObjects: true }) as string[]
  const [index, setIndex] = useState(0)

  useEffect(() => {
    if (!botTyping) return

    setIndex(nextStart)
    nextStart += 1

    const timer = setInterval(() => setIndex((current) => current + 1), ROTATE_MS)
    return () => clearInterval(timer)
  }, [botTyping])

  if (!botTyping) return null

  return (
    <Marker role="status">
      <MarkerIcon className="text-primary">
        <span aria-hidden className="orbit-typing">
          <span className="orbit-typing-core" />
          <span className="orbit-typing-ring" />
        </span>
      </MarkerIcon>
      {/* key: remount on every change so the fade replays */}
      <MarkerContent key={index} className="shimmer animate-fade-in">
        {messages[index % messages.length]}
      </MarkerContent>
    </Marker>
  )
}
